import React, { useEffect, useState } from 'react'
import { Button, Col, Container, Row } from 'react-bootstrap'
import UseSideBarFilter from '../../CustomHooks/Search/UseSideBarFilter'
import { FaBars } from 'react-icons/fa'
import UseViewHide from '../../CustomHooks/UseViewHide'

const SidebarFilter = ({ searchProductsFunc }) => {
  const [Price_From, Price_To, handlePriceFilter, CategoryListArray, AllCategoriesData, AllBrandsData, handleCategoryChecked, handleBrandChecked, HandlePriceFrom, HandlePriceTo] = UseSideBarFilter(searchProductsFunc)
  const [handleSideBarView, View] = UseViewHide()
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return (
    windowWidth < 767 ? (View ? (
      <Row>
        <Button onClick={handleSideBarView} className='dark-bg text-white rounded-0 py-3 fs-30 fw-bold d-flex justify-content-between flex-row align-items-center'>
          <p className='mb-0'>Filter</p>
          <FaBars className="ms-3 d-lg-none d-inline-block" />
        </Button>

        <div className="d-flex flex-column mt-2">
          {AllCategoriesData && AllCategoriesData.length >= 1 ? (<div>
            <div className="fw-bold fs-20">Category</div>
            <div className="d-flex mt-2">
              <input type="checkbox" value="0" onChange={handleCategoryChecked} checked={localStorage.getItem("CategoryArray").length === 0 ? true : false} />
              <div className="fs-16 ms-2" checked>All</div>
            </div></div>) : null}

          {AllCategoriesData && AllCategoriesData.length >= 1 ? (AllCategoriesData.map((item) => {
            return (<div className="d-flex mt-2" key={item._id}>
              <input type="checkbox" value={item._id} onChange={handleCategoryChecked} checked={localStorage.getItem("CategoryArray").includes(item._id) ? true : false} />
              <div className="fs-16 ms-2">{item.name} </div>
            </div>)
          })) : null}
        </div>

        <div className="d-flex flex-column mt-2">
          {AllBrandsData && AllBrandsData.length >= 1 ? (<div>
            <div className="fw-bold fs-20">Brands</div>
            <div className="d-flex mt-2">
              <input type="checkbox" value="0" onChange={handleBrandChecked} checked={localStorage.getItem("BrandArray").length === 0 ? true : false} />
              <div className="fs-16 ms-2" checked>All</div>
            </div></div>) : null}

          {AllBrandsData && AllBrandsData.length >= 1 ? (AllBrandsData.map((item) => {
            return (<div className="d-flex mt-2" key={item._id}>
              <input type="checkbox" value={item._id} onChange={handleBrandChecked} checked={localStorage.getItem("BrandArray").includes(item._id) ? true : false} />
              <div className="fs-16 ms-2">{item.name} </div>
            </div>)
          })) : null}
        </div>

        <div className="fw-bold fs-20 mt-2">Price</div>
        <div className="mb-5">
          <p className="fs-14 my-1 fw-bold">From:</p>
          <input
            onChange={HandlePriceFrom}
            value={localStorage.getItem("priceFrom") || ""}
            className="m-1 text-center form-control p-1"
            type="text"
          />
          <p className="fs-14 my-1 fw-bold">To:</p>
          <input
            onChange={HandlePriceTo}
            value={localStorage.getItem("priceTo") || ""}
            className="m-1 text-center  form-control p-1"
            type="text"
          />
        </div>
      </Row>) : (
      <Button onClick={handleSideBarView} className='w-100 dark-bg text-white rounded-0 py-3 fs-30 fw-bold d-flex justify-content-between flex-row align-items-center'>
        <p className='mb-0'>Filter</p>
        <FaBars className="ms-3 d-lg-none d-inline-block" />
      </Button>


    )) : (<Row>
      <div className="d-flex flex-column mt-2">
        {AllCategoriesData && AllCategoriesData.length >= 1 ? (<div>
          <div className="fw-bold fs-20">Category</div>
          <div className="d-flex mt-2">
            <input type="checkbox" value="0" onChange={handleCategoryChecked} checked={localStorage.getItem("CategoryArray")?.length === 0 ? true : false} />
            <div className="fs-16 ms-2" checked>All</div>
          </div></div>) : null}

        {AllCategoriesData && AllCategoriesData.length >= 1 ? (AllCategoriesData.map((item) => {
          return (<div className="d-flex mt-2" key={item._id}>
            <input type="checkbox" value={item._id} onChange={handleCategoryChecked} checked={localStorage.getItem("CategoryArray")?.includes(item._id) ? true : false} />
            <div className="fs-16 ms-2">{item.name} </div>
          </div>)
        })) : null}
      </div>

      <div className="d-flex flex-column mt-2">
        {AllBrandsData && AllBrandsData.length >= 1 ? (<div>
          <div className="fw-bold fs-20">Brands</div>
          <div className="d-flex mt-2">
            <input type="checkbox" value="0" onChange={handleBrandChecked} checked={localStorage.getItem("BrandArray")?.length === 0 ? true : false} />
            <div className="fs-16 ms-2" checked>All</div>
          </div></div>) : null}

        {AllBrandsData && AllBrandsData.length >= 1 ? (AllBrandsData.map((item) => {
          return (<div className="d-flex mt-2" key={item._id}>
            <input type="checkbox" value={item._id} onChange={handleBrandChecked} checked={localStorage.getItem("BrandArray")?.includes(item._id) ? true : false} />
            <div className="fs-16 ms-2">{item.name} </div>
          </div>)
        })) : null}
      </div>

      <div className="fw-bold fs-20 mt-2">Price</div>
      <div className="mb-5">
        <p className="fs-14 my-1 fw-bold">From:</p>
        <input
          onChange={HandlePriceFrom}
          value={localStorage.getItem("priceFrom") || ""}
          className="m-1 text-center form-control p-1"
          type="text"
        />
        <p className="fs-14 my-1 fw-bold">To:</p>
        <input
          onChange={HandlePriceTo}
          value={localStorage.getItem("priceTo") || ""}
          className="m-1 text-center  form-control p-1"
          type="text"
        />
      </div></Row>)

  )
}

export default SidebarFilter
